import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  primary: {
    main: '#578641',
  },
  brandBlue: {
    lighter: '#94d0e3',
    light: '#6cbed8',
    main: '#44accd',
    dark: '#2f90af',
    darker: '#246f87',
  },
  brandGreen: {
    lighter: '#a6cb95',
    light: '#89ba73',
    main: '#6da852',
    dark: '#578641',
    darker: '#416331',
  },
  brandLightGreen: {
    lighter: '#f2f7ef',
    light: '#e6f0e1',
    main: '#90EE90',
  },
  brandRed: {
    lighter: '#f27270',
    light: '#ee4541',
    main: '#e71915',
    dark: '#b81411',
    darker: '#8a0f0d',
  },
  brandGray: {
    lighter: '#f6f6f6',
    light: '#e8e8e8',
    main: '#afafaf',
    dark: '#7d7d7d',
    darker: '#5a5a5a',
  },
  brandDarkBlue: {
    main: '#2a353d',
  },
  error: {
    main: '#b81411',
  },
  text: {
    primary: '#464646',
    secondary: '#7d7d7d',
  },
  info: {
    light: '#ebf6ff',
    main: '#248ace',
    dark: '#526d80',
  },

  custom: {
    headerText: '#3c4257',

    // stepper
    pendingStep: '#c1c9d2',
    activeStep: '#0099ff',
    completedStep: '#28a745',

    // inputs
    inputLabel: '#2a353d',
    inputBorder: '#e4e2df',
    inputPlaceholder: '#a3a3a3',
    inputHelperText: '#969696',

    // credit score
    creditScoreExcellent: '#56b46c',
    creditScoreVeryGood: '#6bda81',
    creditScoreGood: '#f0b44f',
    creditScoreFair: '#e98445',
    creditScorePoor: '#e6583d',

    // tcpa
    tcpaBackground: '#f6f7f8',
    tcpaText: '#74808b',
    tcpaLink: '#0099ff',

    // win-back modal
    winBackTitle: '#0f172a',
    winBackBodyText: '#475569',
    winBackSubtleText: '#5c6c77',
    winBackCardBorder: '#c4e7f1',
    winBackGoodFitBadge: '#40a40e',
    winBackDaggerText: '#7b8793',
    winBackDisclaimerText: '#5a6672',

    requiredAsterisk: '#e61a1a',
  },
};
